import React, { lazy, Suspense} from "react";

import DefaultLoader from "../utilities/loaders/DefaultLoader";
const SupportContent = lazy(() => import('./SupportContent'));



const Support = () => {
    return (  
        <Suspense fallback={<DefaultLoader />}>
            <SupportContent />
        </Suspense>
    );
}

export default Support;